import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "../../../fnx/showError";
export var usePlanErrorHandling = function (_a) {
    var errorPlans = _a.errorPlans, errorPremiumEvalOptions = _a.errorPremiumEvalOptions, errorCreatePlan = _a.errorCreatePlan, errorCreateCoverType = _a.errorCreateCoverType, errorCreateCoverTypePlan = _a.errorCreateCoverTypePlan, errorDelete = _a.errorDelete, setSeeToast = _a.setSeeToast;
    var t = useTranslation().t;
    useEffect(function () {
        if (errorPlans)
            showErrorToast(errorPlans, setSeeToast, t);
    }, [errorPlans]);
    useEffect(function () {
        if (errorPremiumEvalOptions)
            showErrorToast(errorPremiumEvalOptions, setSeeToast, t);
    }, [errorPremiumEvalOptions]);
    useEffect(function () {
        if (errorCreatePlan)
            showErrorToast(errorCreatePlan, setSeeToast, t);
    }, [errorCreatePlan]);
    useEffect(function () {
        if (errorCreateCoverType)
            showErrorToast(errorCreateCoverType, setSeeToast, t);
    }, [errorCreateCoverType]);
    useEffect(function () {
        if (errorCreateCoverTypePlan)
            showErrorToast(errorCreateCoverTypePlan, setSeeToast, t);
    }, [errorCreateCoverTypePlan]);
    useEffect(function () {
        if (errorDelete)
            showErrorToast(errorDelete, setSeeToast, t);
    }, [errorDelete]);
};
